module.exports = __webpack_public_path__ + "media/images/Database-b30204464558fed2e4a249c739a6b4d2.svg";